@if (isConfirmed) {
  <div class="outcome-container">
    <span class="outcome-badge confirmed-badge" (click)="onBadgeClick()" [style.cursor]="'pointer'">{{ confirmedBadgeText }}</span>
  </div>
} @else if (isDismissed) {
  <div class="outcome-container">
    <span class="outcome-badge dismissed-badge">{{ ss.t('meo_dismissed') }}</span>
  </div>
} @else {
  <div class="suggestion-card" [class.expired]="isExpired">
    <div class="card-header">
      <app-svg [name]="entityIconName" height="18" width="18" [color]="ss.theme().color35"></app-svg>
      <span class="card-title">{{ capitalizedTitle }}</span>
    </div>

    @for (row of cardRows; track $index) {
      <div class="card-row">
        <span class="row-icon-wrap">
          <app-svg [name]="row.icon" height="16" width="16" [color]="ss.theme().color7"></app-svg>
        </span>
        <span class="row-value">{{ row.value }}</span>
        @if (row.rightIcon) {
          <div class="row-right">
            <app-svg [name]="row.rightIcon" height="14" width="14" [color]="ss.theme().color7"></app-svg>
            <span class="row-value">{{ row.rightValue }}</span>
          </div>
        }
      </div>
      @if (row.subText) {
        <div class="row-subtext">{{ row.subText }}</div>
      }
    }

    @if (isPending) {
      <div class="card-actions">
        <button class="action-btn confirm-btn" (click)="onConfirm()">
          {{ actionButtonText }}
        </button>
      </div>
    }
  </div>
}
